@use "../../../../../../../styles/Constants.scss" as Constants;
@use "../../../../../../../styles/Colors.scss" as Colors;

.BillingTypeIndicator {
	$var-size: 20px;
	$var-size-small: 16px;

	display: inline-block;
	padding: Constants.$val-spacing-xs;
	text-transform: uppercase;
	font-size: Constants.$val-fontSizeRegular;
	width: $var-size;
	line-height: $var-size;
	text-align: center;
	padding: 0;
	color: Colors.$col-white;
	border-radius: Constants.$val-borderRadius;
	font-weight: bold;

	&.billableWork {
		background-color: Colors.$color-blue;
	}

	&.materialCost {
		background-color: Colors.$color-rust;
	}

	&.small {
		width: $var-size-small;
		line-height: $var-size-small;
		font-size: Constants.$val-fontSizeSmall;
	}
}
